import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import '../template.module.css';
import BlockNameHeading from './BlockNameHeading';

import { ReportTemplatesContext } from '..';
import { RemoveBlockSVG } from './HelperSVGs';

export function NearestGroupsBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  const style = {
    colorBox: {
      height: '1rem',
      width: '1rem',
    },
    groupBox: {
      display: 'flex',
      gap: '1.25rem',
      alignItems: 'center',
    },
    groupTitle: {
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      textAlign: 'left',
      textDecoration: 'underline',
    },
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '3.5rem',
        borderRadius: '1rem',
        display: 'flex',

        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          paddingX: '1rem',
          paddingY: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <BlockNameHeading title='Nearest Groups' />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          <Box sx={style.groupBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#9494E1',
                },
              ]}
            />
            <Typography sx={style.groupTitle}>
              Bright Young Professionals
            </Typography>
          </Box>
          <Box sx={style.groupBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#FFE773',
                },
              ]}
            />
            <Typography sx={style.groupTitle}>Workday Drive</Typography>
          </Box>
          <Box sx={style.groupBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#B884B7',
                },
              ]}
            />
            <Typography sx={style.groupTitle}>Savvy Suburbanites</Typography>
          </Box>
          <Box sx={style.groupBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#FFE773',
                },
              ]}
            />
            <Typography sx={style.groupTitle}>Urban Edge Families</Typography>
          </Box>
          <Box sx={style.groupBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#72C5B5',
                },
              ]}
            />
            <Typography sx={style.groupTitle}>
              Comfortable Empty Nesters
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          removeBlock('Nearest Groups', 'demographics');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function GradeBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);

  const commonTypographyStyles = {
    fontFamily: 'Lato',
    lineHeight: '20px',
    textAlign: 'center',
  };
  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '1rem',
        borderRadius: '1rem',
        display: 'flex',
        gap: '0.75rem',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          ...commonTypographyStyles,
          fontSize: '1.1rem',
          fontWeight: 500,
          color: '#39585C',
        }}
      >
        Grade
      </Typography>
      <Typography
        sx={{
          ...commonTypographyStyles,
          fontSize: '22.4px',
          fontWeight: 700,
        }}
      >
        7C
      </Typography>

      <Box
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          removeBlock('Grade', 'demographics');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function DemographicGroupBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  const style = {
    colorBox: {
      height: '1rem',
      width: '1rem',
    },
    groupTitle: {
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      textAlign: 'left',
      textDecoration: 'underline',
    },
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1rem',
        paddingX: '1.75rem',
        borderRadius: '1rem',
        display: 'flex',
        gap: '0.75rem',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '0.75rem',
        }}
      >
        <BlockNameHeading title='Demographic Group' />
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: '2rem',
        }}
      >
        <Box
          sx={[
            style.colorBox,
            {
              backgroundColor: '#FFE773',
            },
          ]}
        />
        <Typography sx={style.groupTitle}>Urban Edge Families</Typography>
      </Box>

      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock('Demographic Group', 'demographics');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function WhoWeAreBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1rem',
        paddingX: '1.75rem',
        borderRadius: '1rem',
        display: 'flex',
        gap: '0.75rem',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '.5rem',
        }}
      >
        <BlockNameHeading title={'Who We Are'} />
      </Box>
      <Box>
        <Typography
          sx={{
            fontFamily: 'Lato',
            fontSize: '1rem',
            fontWeight: '400',
            textAlign: 'justify',
          }}
        >
          On their own for the first time, Dorms to Diplomas residents are just
          learning about finance and cooking. Frozen dinners and fast food are
          common options. Shopping trips are sporadic, and preferences for
          products are still being established. Many carry a balance on their
          credit card so they can buy what they want now.
        </Typography>
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock('Who We Are', 'demographics');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}
